//@ts-ignore
import { SUBJECTS_SLUGS } from '@yandex-int/k-common/constants';
import { useParams } from 'react-router';

type Params = { subject: SUBJECTS_SLUGS; classId: string };

export function useLessonViewParams() {
    return useParams<Params>();
}
